import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import R from 'ramda';
import { HeroFullOverlay, HeroFullBlock } from '@cotyorg/ccx-organism-hero';
import Paragraph from '@cotyorg/ccx-atoms/Paragraph';
import OptionalSection from '@cotyorg/ccx-utils/js/components/OptionalSection';
import { CardsCarousel } from '@cotyorg/ccx-organism-carousel';
import Heading from '@cotyorg/ccx-atoms/Heading';
import SectionHeader from '../../../atoms/SectionHeader';
import {
  cardsDefaultConfig,
  cardsPerPageDefaultConfig,
  carouselDefaultConfig,
} from '../config';

const LooksArticleImageAndCopyComponent = ({
  paragraphs,
  noOfHeroes,
  cards,
  sectionHeadings,
}) => (
  <div className="image-and-copy-page">
    <div className="grid-container">
      <div className="grid-x grid-margin-x">
        <div className="cell">
          <HeroFullOverlay heroStoreDataKey="mainHero" />
        </div>

        <div className="cell xsmall-14 xsmall-offset-1 large-9 large-offset-1">
          <Paragraph>{R.prop('introduction', paragraphs)}</Paragraph>
        </div>

        <div className="cell xsmall-14 xsmall-offset-1">
          {[...Array(noOfHeroes)].map((item, index) => (
            <HeroFullBlock
              heroStoreDataKey={`hero${index + 1}`}
              layout="vertical"
              isUnderlined={false}
            />
          ))}
        </div>

        <OptionalSection
          renderCondition={!!R.length(R.prop('carousel1', cards))}
          section={() => (
            <div className="cell">
              <SectionHeader>
                <Heading extraClass="section__title" level={2}>
                  {R.path(['carouselHeading', 'heading'])(sectionHeadings)}
                </Heading>
              </SectionHeader>

              <CardsCarousel
                cards={{
                  cardsStoreDataKey: 'carousel1',
                  ...cardsDefaultConfig,
                }}
                carousel={{
                  carouselsStoreDataKey: 'carousel1',
                  ...carouselDefaultConfig,
                }}
                cardsPerPageMap={cardsPerPageDefaultConfig}
              />
            </div>
          )}
        />
      </div>
    </div>
  </div>
);

LooksArticleImageAndCopyComponent.propTypes = {
  paragraphs: PropTypes.objectOf(PropTypes.string),
  noOfHeroes: PropTypes.number,
  cards: PropTypes.objectOf(PropTypes.object),
  sectionHeadings: PropTypes.objectOf(PropTypes.object),
};

export default connect(({ content }) => ({
  paragraphs: R.prop('paragraphs', content),
  noOfHeroes: R.path(['custom', 'noOfHeroes'], content),
  sectionHeadings: R.prop('sectionHeadings', content),
  cards: R.prop('cards', content),
}))(LooksArticleImageAndCopyComponent);
